<div #header mat-dialog-title>{{dialogTitle}}</div>

<mat-dialog-content style="overflow: hidden;">
    <tyl-form-field label="Folder Name" style="width: 100%;" class="standardField">
        <input #folderNameRef required matInput name='name' title="Folder Name" id="foldername" type='text'
            [(ngModel)]="myReportFolder.FolderName" maxlength="100" />
    </tyl-form-field>

    <tyl-form-field label="Description" style="width: 100%;" class="standardField">
        <textarea matInput name="txtDescription" Id="txtDescription"
            style="resize: none;width:100%;vertical-align:top;padding-top:0px;padding-bottom:0px;"
            [(ngModel)]="myReportFolder.FolderDescription" rows="4" maxlength="400"></textarea>
    </tyl-form-field>
</mat-dialog-content>

<mat-dialog-actions #footer>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errorLists"></error-prompt>
        <tyl-button *ngIf="editMode == false" image="save and new.png" label="Save and New"
            (clickEvent)="saveAndNewClick()"></tyl-button>
        <tyl-button image="save.png" label="Save" (click)="saveClick()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (click)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>